// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"327":"820d245844f7e66f","533":"0ca92405526b79d9"}[chunkId] + ".css";
};